import KeenSlider from "keen-slider";
import { sliderAnimation } from "helpers/sliderConfig";

(function (): void {
    const blocks = document.querySelectorAll<HTMLElement>(".js-testimonial-slider-block");
    if (blocks.length === 0) return;

    blocks.forEach((block) => {
        const container = block.querySelector<HTMLElement>(".js-card-slide");
        if (!container || container.classList.contains("unslide")) return;

        const track = container.querySelector<HTMLElement>(".slider__track");
        if (!track) return;

        const slides = Array.from(track.querySelectorAll<HTMLElement>(".slide"));
        if (slides.length === 0) return;

        track.classList.add("keen-slider");
        slides.forEach((slide) => slide.classList.add("keen-slider__slide"));

        const prevBtn = container.querySelector<HTMLButtonElement>(".card__prev");
        const nextBtn = container.querySelector<HTMLButtonElement>(".card__next");
        const counter = block.querySelector<HTMLElement>(".counter-current");

        const updateButtons = (slider: { track: { details: { rel: number; maxIdx: number } } }): void => {
            const { rel, maxIdx } = slider.track.details;
            if (prevBtn) {
                if (rel <= 0) prevBtn.setAttribute("disabled", ""); else prevBtn.removeAttribute("disabled");
            }
            if (nextBtn) {
                if (rel >= maxIdx) nextBtn.setAttribute("disabled", ""); else nextBtn.removeAttribute("disabled");
            }
            if (counter) {
                counter.style.transition = "opacity 150ms ease-in-out";
                counter.style.opacity = "0";
                setTimeout(() => {
                    counter.textContent = String(rel + 1);
                    counter.style.opacity = "1";
                }, 150);
            }
        };

        const keenSlider = new KeenSlider(track, {
            mode: "snap",
            slides: { perView: 1, spacing: 0 },
            defaultAnimation: sliderAnimation,
            created(s) { updateButtons(s); },
            slideChanged(s) { updateButtons(s); }
        });

        prevBtn?.addEventListener("click", () => keenSlider.prev());
        nextBtn?.addEventListener("click", () => keenSlider.next());
    });
})();
